export default {
    born: {
        formProp: 'born',
        form: {
            label: 'In what city were you born?',
            colon: false,
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'City born...'
        },
        validation: [
            'regex:^[0-9a-zA-Z ]*$:Only letters, numbers and spaces allowed.'
        ]
    },
    food: {
        formProp: 'food',
        form: {
            label: 'What is your favorite food?',
            colon: false,
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Favorite food...'
        },
        validation: [
            'regex:^[0-9a-zA-Z ]*$:Only letters, numbers and spaces allowed.'
        ]
    },
    color: {
        formProp: 'color',
        form: {
            label: 'What is your favorite color?',
            colon: false,
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Favorite color...'
        },
        validation: [
            'regex:^[0-9a-zA-Z ]*$:Only letters, numbers and spaces allowed.'
        ]
    }
}
